import {

  GET_CUSTOMERS_FAIL,
  GET_CUSTOMERS_SUCCESS,

  GET_CUSTOMER_DETAIL_SUCCESS,
  GET_CUSTOMER_DETAIL_FAIL,

  DELETE_CUSTOMER_SUCCESS

} from "./actionTypes"

const INIT_STATE = {
  customers: [],
  customer: {},
}

const Customers = (state = INIT_STATE, action) => {

  switch (action.type) {

    case GET_CUSTOMERS_SUCCESS:
      return {
        ...state,
        customers: action.payload,
      }

    case GET_CUSTOMERS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_CUSTOMER_DETAIL_SUCCESS:
      return {
        ...state,
        customer: action.payload,
      }

    case GET_CUSTOMER_DETAIL_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case DELETE_CUSTOMER_SUCCESS:
      return {
        ...state,
        customers: state.customers.docs.filter(
          customer => customer._id !== action.payload.id
        ),
      }

    default:
      return state
  }
}

export default Customers
